"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputForNatLangForm = TextInputForNatLangForm;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TextInputForNatLangForm(_ref) {
  var {
    errors,
    touched,
    fieldName,
    values,
    type,
    inputMode,
    maxLength,
    placeholder,
    onChange,
    onBlur,
    htmlSize,
    preText,
    postText,
    append,
    prepend,
    className,
    id,
    ariaLabel
  } = _ref;
  var compClass = className ? className : '';
  var optionalAttributes = {};
  ariaLabel ? optionalAttributes['aria-label'] = ariaLabel : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: id ? id : fieldName
  }, preText), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors[fieldName] && touched[fieldName] && 'is-invalid', " ").concat(compClass)
  }, prepend && /*#__PURE__*/_react.default.createElement(PrependInput, {
    symbol: "$"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, _extends({
    id: id ? id : fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: fieldName,
    value: values[fieldName],
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    htmlSize: htmlSize
  }, optionalAttributes)), append && /*#__PURE__*/_react.default.createElement(AppendInput, {
    symbol: "%"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback",
    tooltip: true
  }, errors[fieldName]), typeof className === 'string' && className.includes('endOfSentence') ? '.' : null), postText);
}
function PrependInput(_ref2) {
  var {
    symbol
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, symbol));
}
function AppendInput(_ref3) {
  var {
    symbol
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, symbol));
}